<div *ngIf="loading" class="spinner-wrap">
  <xormon-loading-indicator></xormon-loading-indicator>
</div>
<div class="card" [hidden]="loading">
  <div class="card-body">
    <div id="reporterHistory" class="tablesorter-wrapper reporter-history"></div>
  </div>
</div>
